import AbortController from 'abort-controller';
import * as DateFns from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

import { SERVER } from '../../config/server.config';
import {
  CONTROLLER_SET,
  SCOPE,
  PRACTICE,
  GAME,
  LIVE,
  PAST_PRACTICE,
  PAST_GAME
} from '../../config/constants';
import { clearGames, routeToDate, routeToScheduleScope, generatorHandler } from '../../helpers/helpers';
import { routeToScope } from '../../helpers/helpersts';
import * as eventsType from '../types/events';
import { requestData } from '../../config/services/datasets';
import { addLoadingFlag, subLoadingFlag } from './loading';
import { changeScheduleFetchFlag, createAndGoPracticeFlag } from './flags';
import { updateMetaDataEvent, replaceHighlightsDataEvent, toDataEvents, updatePracticesDataEvents, replaceZonesThresholdsDataEvent } from './dataEvents';
import { toMetaDataEvents } from './dataEvents';
import { defaultDataEvent } from '../reducers/init';

export const replaceEvents = (events, scheduleScope) => {
  return {
    type: eventsType.REPLACE_EVENTS,
    events,
    scheduleScope
  };
};

const eventsGenerator = generatorHandler(
  function* (startDate, endDate, league, live, scheduleScope, scope, loader, dispatch, controller, isSync, isMobile, createAndGo) {
    yield new Promise((resolve) => setTimeout(resolve, 1010));
    dispatch(setLoadedEvents(startDate, endDate, league, live, scheduleScope, scope, loader, controller, isSync, isMobile, createAndGo));
  }
  , (...args) => {
    const scope = args[5];
    const loader = args[6];
    const dispatch = args[7];

    if (loader) {
      dispatch(subLoadingFlag(scope));
    }
    dispatch(changeScheduleFetchFlag(true));
  }
);

export const loadEvents = (priority, live, backgroundReplace, forcePath, isSync, isMobile, createAndGo) => { // backgroundReplace=TRUE if you need update and replace de events without loader
  return async (dispatch, getState) => {
    const path = forcePath || getState().router.location.pathname;
    const pathOnlyDate = path.split('/').slice(0, 6).join('/');
    const scheduleScope = routeToScheduleScope(pathOnlyDate);
    if (getState().events[scheduleScope] && !live && !backgroundReplace) {
      return;
    }
    const scope = routeToScope(path);
    let startDate, endDate;
    const selectedDate = routeToDate(path);
    if (scope === SCOPE.SCHEDULE.MONTH.PAGE) {
      startDate = DateFns.startOfWeek(DateFns.startOfMonth(selectedDate));
      endDate = DateFns.endOfWeek(DateFns.endOfMonth(selectedDate));
    } else {
      startDate = DateFns.startOfWeek(selectedDate);
      endDate = DateFns.endOfWeek(selectedDate);
    }
    const nowDate = new Date();
    if (live && !(DateFns.isWithinInterval(nowDate, { start: startDate, end: endDate }))) {
      return;
    }
    if (live) {
      const selectedDate = nowDate;
      startDate = DateFns.startOfDay(selectedDate);
      endDate = DateFns.endOfDay(selectedDate);
    }

    if (getState().flags.scheduleFetch || priority) {
      const loader = (priority && !backgroundReplace) || !getState().events[scheduleScope];
      if (loader) {
        dispatch(addLoadingFlag(scope));
      }
      dispatch(changeScheduleFetchFlag(false));

      const controller = new AbortController();


      //CONTROLLERS.push(controller);
      const user = getState().user;
      let league = user.league;
      if (league === '*') {
        league = 'ncaa-fbs,ncaa-mlax,nfl';
      }

      eventsGenerator(startDate, endDate, league, live, scheduleScope, scope, loader, dispatch, controller, isSync, isMobile, createAndGo);

    }
  };
};

const formatPracticeToDataEvents = (result, dataEvents) => {
  const { meta } = toDataEvents(result);

  if (!dataEvents[meta.gameId]) {
    if (meta.type === PAST_PRACTICE || meta.type === PAST_GAME) {
      dataEvents[meta.gameId] = JSON.parse(JSON.stringify({ ...defaultDataEvent(meta.homeTeam.teamId), ...defaultDataEvent(meta.visitorTeam.teamId) }));
    } else {
      dataEvents[meta.gameId] = JSON.parse(JSON.stringify(defaultDataEvent()));
    }
  }

  dataEvents[meta.gameId].meta = dataEvents[meta.gameId].meta ? { ...dataEvents[meta.gameId].meta, ...meta } : { ...meta };
  if (!dataEvents[meta.gameId].mongoId) {
    dataEvents[meta.gameId].mongoId = meta._id;
  }

  return { [meta.gameId]: dataEvents[meta.gameId] };
};

const setLoadedEvents = (startDate, endDate, league, live, scheduleScope, scope, loader, controller, isSync, isMobile, createAndGo) => {
  return async (dispatch, getState) => {
    CONTROLLER_SET.add(controller);
    let results = await requestData(SERVER.NEW_SCHEDULE_LIST(startDate.getTime(),
      endDate.getTime(), league, isSync, isMobile),
      { signal: controller.signal }
    );
    CONTROLLER_SET.delete(controller);

    if (results && results[0] !== "") {
      const nowDate = new Date();
      results.map((event) => {
        if (event.type === PRACTICE) {
          event.live = (event.status === LIVE);
        }
        event.endTime = event.endTime ? event.endTime : event.startTime + 1;
        if (event.type === GAME) {
          event.isFuture = DateFns.isFuture(event.startTime);
          event.homeTeamAbbr = event.homeTeamId === '194' || event.homeTeamId === '19410' ? 'OSU' : event.homeTeamAbbr;
          event = Object.assign(event, {
            dist: {
              A: 0,
              B: 0
            },
            speed: {
              A: 0,
              B: 0
            },
            effort: {
              A: 0,
              B: 0
            }
          });
          if (event.scheduledStartTimeEasern === '' || !event.scheduledStartTimeEasern) {
            event.scheduledStartTimeEasern = DateFns.format(utcToZonedTime(new Date(event.startTime), 'America/New_York'), 'HH:mm:ss');
          }
        }
        return event;
      });

      results = clearGames(results);

      // BEGIN DataEvents
      const { dataEvents } = getState();
      let practices = {};
      results.forEach(result => {
        const practice = formatPracticeToDataEvents(result, dataEvents);
        practices = { ...practices, ...practice };
      });
      dispatch(updatePracticesDataEvents(practices));

      // END Data Events
      if (live) {
        dispatch(replaceEvents(results, SCOPE.SCHEDULE.TODAY));
      } else {
        const todayEvents = results.filter(event => DateFns.isSameDay(nowDate, new Date(event.startTime)));
        if (todayEvents.length > 0) {
          dispatch(replaceEvents(todayEvents, SCOPE.SCHEDULE.TODAY));
        }
        dispatch(replaceEvents(results, scheduleScope));
      }
    }
    if(typeof createAndGo !== 'undefined'){
      dispatch(createAndGoPracticeFlag(false));
      createAndGo();
    }  
    if (loader) {
      dispatch(subLoadingFlag(scope));
    }
    dispatch(changeScheduleFetchFlag(true));
  };
};

export const loadPracticeEvent = (gameId) => {
  return async (dispatch, getState) => {
    const results = await requestData(SERVER.DATAACCESS_HIGHLIGHT(gameId));
    if (results && results[0]) {
      // BEGIN DataEvents
      const practiceData = {
        meta: toMetaDataEvents(results[0]),
        highlights: {
          noData: Object.keys(results[0]).length === 0 ? 'noData' : '',
          sessionInfo: results[0].sessionInfo,
          aveMaxSpeedMPH: results[0].aveMaxSpeedMPH ? results[0].aveMaxSpeedMPH : 0,
          aveMaxSpeedYPM: results[0].aveMaxSpeedYPM,
          aveMaxSustainedSpeedMPH: results[0].aveMaxSustainedSpeedMPH ? results[0].aveMaxSustainedSpeedMPH : 0,
          aveMaxSustainedSpeedYPM: results[0].aveMaxSustainedSpeedYPM,
          // totalAveDist: practice.totalAveDist,
          // extra for modal
          aveHardEffortDist: results[0].aveHardEffortDist ? results[0].aveHardEffortDist : 0,
          aveDistYards: results[0].aveDistYards ? results[0].aveDistYards : 0,
          'aveDistYards_%': results[0]['aveDistYards_%'],
          'aveHardEffortDist_%': results[0]['aveHardEffortDist_%'] ? results[0]['aveHardEffortDist_%'] : 0,
          aveYPM: results[0].aveYPM ? results[0].aveYPM : 0,
          'aveYPM_%': results[0]['aveYPM_%'] ? results[0]['aveYPM_%'] : 0,
          'aveMaxSpeedMPH_%': results[0]['aveMaxSpeedMPH_%'] ? results[0]['aveMaxSpeedMPH_%'] : 0,
          'aveMaxSustainedSpeedMPH_%': results[0]['aveMaxSustainedSpeedMPH_%'] ? results[0]['aveMaxSustainedSpeedMPH_%'] : 0,
          aveExertionIndex: results[0].aveExertionIndex ? results[0].aveExertionIndex : 0,
          'aveExertionIndex_%': results[0]['aveExertionIndex_%'] ? results[0]['aveExertionIndex_%'] : 0,
          aveSprintCount: results[0].aveSprintCount ? results[0].aveSprintCount : 0,
          'aveSprintCount_%': results[0]['aveSprintCount_%'] ? results[0]['aveSprintCount_%'] : 0
        }
      };
      dispatch(updateMetaDataEvent(practiceData.meta.gameId, practiceData.meta));
      dispatch(replaceHighlightsDataEvent(practiceData.meta.gameId, practiceData.highlights));
      dispatch(replaceZonesThresholdsDataEvent(practiceData.meta.gameId, practiceData.zones));
      // END Data Events
    }
  };
};
